<template>
  <base-layout>
    <template #header></template>
    <template #default>
      <el-row class="main-div">
        <el-col class="princess-title">
          <h3>{{ princess.title }}</h3>
          <div style="width: 84%;margin: auto; padding: 0  8px  8px  8px; color: white; font-size: 16px;">
            <span class="textTitle">身高：</span><span>{{ princess.stature }}</span>
            <span class="textTitle">三围：</span><span>{{ princess.cir }}</span>
          </div>
        </el-col>
        <el-col class="princess-value">{{ princess.value }}</el-col>
        <el-col class="princess-content">

            <div class="prin-img"
              v-for="(item, index) in srcList"
              :key="index"
            >
              <el-image
                class="princess-img"
                :src="srcList[index]"
                :preview-src-list="srcList"
                :alt="errMsg"
                lazy
              >
                <div slot="error">
                  西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所
                </div>
                <div sort="placeholder">
                  西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所
                </div>
              </el-image>
            </div>
          <div class="clearfix" ></div>
          <div v-if="princess.videourls" :class="princess.videourls.length>3?'is-show':'is-show'">
            <VideoPlayer :videoUrl="princess.videourls" />
          </div>

            <div class="clearfix" ></div>
            <div class="princess-info">


              <div v-if="princess.pricelist">
                <div class="price-item"  v-for="(prItem ,pi ) in princess.pricelist">
                  <span class="textTitle"> {{prItem.price}}</span> <br>
                  <span>{{prItem.des}}</span>
                </div>
              </div>


              <span ><span class="textTitle">个人资料：</span><span v-html="princess.infocontent"></span>
              </span>
            </div>
        </el-col>

        <el-col class="home-contact">
          <div class="box-card">
            <div slot="header" class="clearfix">
              <a
                :href="'tel:' + $store.state.contactConfig.phone2"
                class="telcolor"
              >
                {{ $store.state.contactConfig.phone2 }} 来电预约
                <i class="iconfont icon-a-dianhuazhichibangzhuzixun"></i>
              </a>
              <br />
              <br />
              <span class="servicetimewarp"
                >营业时间：11:00 AM - 01:00 AM
              </span>
            </div>
            <tabsView></tabsView>
          </div>

          <div class="box-card home-map">
            <i class="iconfont icon-dingwei"></i>
            <span>地址：西雅图Bellevue</span>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer></template>
  </base-layout>
</template>

<script>
let _th;
import BaseLayout from "@/components/BaseLayout";
import tabsView from "@/components/mytabs";
import  VideoPlayer from "@/components/base/VideoPlayer"
export default {
  data() {
    return {
      fastBool: true,
      errMsg:
        "西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所",
      princess: {
        currentPage4: "",
        title: "",
        value: "",
        stature: "",
        cir: "",
        pricejson: {},
        info: ""
      },
      src: "",
      srcList: [],
      crrentId: 0
    };
  },
  components: {
    BaseLayout,
    tabsView,
    VideoPlayer
  },
  mounted() {
    _th = this;
    setInterval(function() {
      _th.initFun();
    }, 200);
  },
  methods: {
    initFun() {
      try {
        let paramid = this.$route.query.id ? this.$route.query.id : 0;
        if (paramid == 0) {
          return;
        }
        let k = parseInt(paramid) - 1;

        if (paramid == this.crrentId) {
          return;
        }
        var _sd = document.querySelector("#app");
          _sd.scrollTop = 3;
        this.crrentId = paramid;

        let arr = JSON.parse(_th.$sesionStorage.getItem("userId"));

        arr.forEach((o, i) => {
          if (i === k) {
            this.princess = arr[k];
            this.srcList = arr[k].pic;
            document.title = arr[k].title + "-西雅图桃桃私人会所";
          }
        });
      } catch (e) {}
    }
  }
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: 767px) {
  /deep/ .el-image__inner {
    height: 168px !important;
  }
  .princess-info {
    margin: 0.8rem ;
    text-align: left;
    line-height: 2rem;
    color: #cfcfcf;
  }

}

@media only screen and (min-width: 768px) {
  /deep/ .el-image__inner {
    height: 468px !important;
  }
  .princess-info {
    margin: 0.8rem 10% ;
    text-align: left;
    line-height: 2rem;
    color: #cfcfcf;
  }


}

.clearfix::after{
  content: "";
  display: block;
  clear: both;
  height: 1px ;
}

i {
  font-size: 1.75rem;
}
.main-div {
  background-color: black;
}
.princess-title {
  background-color: #1a1a1a;
  color: #fff;
  font-size: 1.5rem;
}
.prin-img{width: 32%; margin-left: 1%;float:left;}
.princess-img{
  //pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.box-card{
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;color: #cfcfcf;
}
.princess-value,
.princess-content {
  background-color: #1a1a1a;
}
.princess-value {
  text-align: left;
  text-indent: 1rem;
  word-break: normal;
  line-height: 2rem;
}
.princess-content {
  margin-top: 1rem;
  background-color: #1a1a1a;
  position: relative;
}

.textTitle{
  color: #dc143c;
}

.is-hide{
  display: none;
}
.is-show{
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/page/princess.vue